import { FlagEvent, PauseEvent, RandomizeEvent } from "../../events";
import { ItemId, Serializer } from "../../model/datasource";
import { ContentItem } from "../../model/datasource/item";
import { BindRecord } from "./frontend";

export function renderTime(time: number): string {
	const rounded = Math.round(time / 1000);
	const hours = Math.trunc(rounded / 60 / 60);
	const minutes = Math.trunc(rounded / 60) % 60;
	const seconds = rounded % 60;
	return `${
		hours ? hours + ':' : ''
	}${
		('00' + minutes).slice(-2)
	}:${
		('00' + seconds).slice(-2)
	}`;
}

export abstract class HeaderFrontend<I extends ItemId> {
	itemIdSerializer: Serializer<I>;
	constructor(item: Serializer<I>) {
		this.itemIdSerializer = item;
	}

	getBindPause(): BindRecord {
		return new BindRecord(
			document.querySelectorAll('.pause'),
			'click',
			element => new PauseEvent(true)
		);
	}

	getBindFlag(): BindRecord {
		return new BindRecord<HTMLInputElement>(
			document.querySelectorAll('input.flag'),
			'change',
			element => new FlagEvent(element.checked)
		);
	}

	getBindRandomize(): BindRecord {
		return new BindRecord<HTMLInputElement>(
			document.querySelectorAll('input.randomize'),
			'change',
			element => new RandomizeEvent(element.checked)
		)
	}

	getProgressChart(): Element {
		return document.querySelector('.item-progress');
	}

	getTotalScoreChart(): Element {
		return document.querySelector('.total-score');
	}

	abstract displayItem(content: ContentItem<I>): void

	displayTotalTime(time: number): void {
		document.querySelectorAll('.total-timer .input-group-text')
			.forEach(label => label.innerHTML = renderTime(time));
	}

	displayTimer(show: boolean): void {
		const timer = document.querySelector('.total-timer');
		timer.classList.toggle('invisible', !show);
	}

	displayNext(show: boolean): void {
		const next = document.querySelectorAll('.next');
		next.forEach(n => {
			n.classList.toggle('disabled', !show);
			n.classList.toggle('btn-light', !show);
			n.classList.toggle('btn-primary', show);
		});
	}

	displayPrevious(show: boolean): void {
		const next = document.querySelectorAll('.prev');
		next.forEach(n => n.classList.toggle('disabled', !show));
	}

	displayFinish(show: boolean): void {
		const finish = document.querySelectorAll('[data-target=".finish-test"]');
		const toggle = document.querySelectorAll('.toggle[data-target=".finish-test"]');
		const next = document.querySelectorAll('.next');
		finish.forEach(f => {
			f.classList.toggle('btn-primary', show);
			f.classList.toggle('btn-secondary', !show);
		});
		toggle.forEach(t => {
			t.classList.toggle('d-none', !show);
		});
		next.forEach(n => {
			n.classList.toggle('d-none', show);
		});
	}

	displayFlag(flagged: boolean): void {
		const next = document.querySelectorAll<HTMLInputElement>('input.flag');
		next.forEach(n => n.checked = flagged);
	}

	displayCountdown(show: boolean): void {
		const advance = document.querySelector('.countdown');
		advance.classList.toggle('invisible', !show);
	}

	displayCurrentTime(time: number): void {
		document.querySelectorAll('.item-timer .input-group-text')
			.forEach(label => label.innerHTML = renderTime(time));
	}

	displayCountdownTime(time: number): void {
		document.querySelectorAll('.countdown-timer .input-group-text')
			.forEach(label => label.innerHTML = `${Math.round(time / 1000)} seconds left`);
	}

	displayRandomize(randomize: boolean): void {
		document.querySelectorAll<HTMLInputElement>('input.randomize')
			.forEach(n => n.checked = randomize);
	}

	displayPosition(index: number, length: number): void {
		document.querySelectorAll('.item-position')
			.forEach(n => n.textContent = `${index + 1} of ${length}`);
	}
}

export class PqHeaderFrontend<I extends ItemId> extends HeaderFrontend<I> {
	displayItem(content: ContentItem<I>): void {
		const title = document.querySelector('.section-title');
		title.innerHTML = `${content.section_title} - Question ${content.name}`;
	}
}

export class FlashHeaderFrontend<I extends ItemId> extends HeaderFrontend<I> {
	displayItem(content: ContentItem<I>): void {
		const title = document.querySelector('.section-title');
		title.innerHTML = content.section_title;
	}

	displayFlip(front: boolean): void {
		document.querySelectorAll('.flip-card').forEach(n => {
			n.classList.toggle('show-question', !front);
			n.classList.toggle('show-answer', front);
		});
		document.querySelectorAll([
			'button.flip-card',
			'input[type=button].flip-card'
		].join(', ')).forEach(n => {
			n.textContent = front ? 'Show Answer' : 'Show Question';
		});
		document.querySelectorAll([
			'.card-type'
		].join(', ')).forEach(n => {
			n.textContent = front ? 'Question' : 'Answer';
		});
	}
}
